import React, {useState} from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classes from './ScrollToTopArrow.module.css';


const ScrollToTopArrow = () =>{

  const [showScroll, setShowScroll] = useState(false)

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 1000){
      setShowScroll(true)
    } else if (showScroll && window.pageYOffset <= 1000){
      setShowScroll(false)
    }
  };

  const scrollTop = () =>{
    window.scrollTo({top: 0, behavior: 'smooth'});
  };

  window.addEventListener('scroll', checkScrollTop)

  return (
    <div>
      <FontAwesomeIcon icon={["fas", "arrow-circle-up"]} className={classes.scrollTop} onClick={scrollTop} style={{opacity: showScroll ? '1' : '0'}}/>
    </div>
  );
}

export default ScrollToTopArrow;
